module.exports = __webpack_public_path__ + "a27b53341a6830553f3a578b0d50c0a4.MP3";